// Ultra-Luxury Motorcoaches — flagship collection imagery.
//
// Iteration 109: Owner-approved Ultra-Luxury refresh landed via the
// canonical manifest (see /lib/photos/manifest.js).  The 5 new
// owner-approved photos (Prevost H3-45 Millennium, Prevost Vantaré,
// Prevost X3-45, Newell, Newmar King Aire) are wired here.  The
// branded Vanturis-owned homepage hero (/assets/hero/vanturis-hero-1320.jpg)
// is preserved as the site-wide preloaded hero so the homepage marquee
// and index.html preload continue to hit the same asset.
import { _ASSET_BASE, INTERIOR_PHOTOS } from "./_base";

// Iter 78: preloaded via responsive srcset in index.html + ComingSoonHome.jsx.
const ULTRA_LUXURY_HERO = "/assets/hero/vanturis-hero-1320.jpg";

// Iter 109 owner-approved refresh (canonical manifest ids on right).
const UL_MILLENNIUM = `${_ASSET_BASE}/dryx3kfs_IMG_5620.jpeg`; // Prevost H3-45 Millennium
const UL_VANTARE    = `${_ASSET_BASE}/d3dyirq1_IMG_5619.jpeg`; // Prevost Vantaré
const UL_X3_45      = `${_ASSET_BASE}/rsmcaorb_IMG_5621.jpeg`; // Prevost X3-45 · dramatic sky
const UL_NEWELL     = `${_ASSET_BASE}/x52g5eqn_IMG_5623.jpeg`; // Newell · red graphics · cliffs
const UL_KING_AIRE  = `${_ASSET_BASE}/7rnhbgip_IMG_5624.jpeg`; // Newmar King Aire · buttes

// Full photograph library for the Ultra-Luxury collection.
export const ULTRA_LUXURY_PHOTOS = [
  ULTRA_LUXURY_HERO,
  UL_MILLENNIUM,
  UL_VANTARE,
  UL_X3_45,
  UL_NEWELL,
  UL_KING_AIRE,
];

// Cinematic, dramatic-sky Newell frame — used for the homepage Land · Air · Water
// LAND banner so it shares the editorial mood of the Air/Water cards instead of
// reusing the bright site hero. Owner-approved (Iter 109 refresh); coach-only.
export const ULTRA_LUXURY_CARD_CINEMATIC = UL_NEWELL;

const ultraLuxury = {
  hero: ULTRA_LUXURY_HERO,   // Vanturis-owned; matches preload in index.html
  accent: UL_MILLENNIUM,     // Prevost H3-45 Millennium
  gallery: [
    UL_VANTARE,
    UL_X3_45,
    UL_NEWELL,
    UL_KING_AIRE,
  ],
  card: ULTRA_LUXURY_HERO,
  social: ULTRA_LUXURY_HERO,
};

export default ultraLuxury;
// Silence unused import warning; INTERIOR_PHOTOS is intentionally exported for
// downstream callers who consume the barrel and expect the legacy shape.
export { INTERIOR_PHOTOS };
